
import Footer from '../components/Home/Footer'
import Navbar from '../components/Navbar/Navbar'
import TermsConditions from '../components/Privacyandterms/TermsConditions'





const Termspage = () => {
  return (
    <div>
        <Navbar/>
        <TermsConditions/>

        <Footer/>
    </div>
  )
}

export default Termspage